export function formatDate(date) {
    if (!date) {
        date = new Date()
    }
    return new Intl.DateTimeFormat('en-US', {
        weekday: 'short', month: 'short', day: 'numeric'
    }).format(date)
}